import useDebounce from "hooks/others/useDebounce";
import { useInfiniteQuery, useQueryClient } from "react-query";
import { GetTechnicalWorkSchedule } from "services/workSchedule";

export default function useGetTechnicalworkSchedule(obj: { search: string;}) {
    const { newParam: searchParam } = useDebounce(obj.search);
    const queryKey = ["technical-workSchedule",searchParam];
    return useInfiniteQuery(
        queryKey,
        async ({ pageParam = 1 }) => GetTechnicalWorkSchedule(pageParam, searchParam),
        {
            getNextPageParam: (lastPage) =>
            {
                return lastPage.meta.nextPageUrl ? lastPage.meta.currentPage + 1 : undefined;
            }
        }
    );
}